const HisInfo = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg
      style = {_sx}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1797 22.5156C17.7025 22.5156 22.1797 18.0385 22.1797 12.5156C22.1797 6.99278 17.7025 2.51562 12.1797 2.51562C6.65684 2.51562 2.17969 6.99278 2.17969 12.5156C2.17969 18.0385 6.65684 22.5156 12.1797 22.5156Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1797 16.5156V12.5156"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1797 8.51562H12.1897"
         stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisInfo;
